import React from 'react'
import styled from "styled-components"
import Moment from "moment"
import { IoMdArrowDropright } from 'react-icons/io';
import {Link} from "gatsby"
import {convertImgSrc,convertLink} from "../functions"

var Container = styled.div`
    /* font-family:'Roboto'; */
    width: 100%;
    height: 50%;
    color: #000000;
    text-align: center;
    position: relative;
    background-image:url("${props=>props.src}");
    transition: all .5s ease-in-out; 
    background-position: center;
    background-size: cover;
`

var Title =  styled.div`
    color: #e10000;
    font-size: 18px;
    margin: 0px;
    position: absolute;
    width: 96%;
    height: 100%;
    left: 0;
    top: 51%;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    padding:5px;
    @media screen and (max-width:500px){
        font-size: 18px;
    }
`
var Location =  styled.div`
    font-size: 14px;
    margin-top: 3%;
    display: block;
    width: 96%;
    color: #999;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    padding-left: 5px;
    @media screen and (max-width:500px){
        margin-top: 18%;
    }
`
var Information =  styled.div`
    font-size: 14px;
    display: block;
    width: 96%;
    color: #000;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    padding-left: 5px;
    @media screen and (max-width:500px){
        font-size: 14px;
    }
`

var Boxhover = styled.div`
    width: 258px;
    height: 360px;
    display: inline-block;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
    margin: 5px;
    border: solid 1px #efefef;
    border-color: rgb(239, 239, 239);
    & :hover ${Container} {
    transform: scale(1.1);
    }
    @media screen and (max-width:500px){
        width: 90%;
        height: 420px;
    }
`

var Contentbox = styled.div`
    font-size: 20px;
    display: inline-grid;
    grid-gap: 5%;
    right: 0;
    left: 0;
`
var Price = styled.p`
    font-weight: bold;
    transform: rotate(-40deg);
    color:white;
    background-color:red;
    margin-left: -40px;
    padding-right: 95px;
    width: 68%;
    margin-top: auto;
    height: 25px;
    padding-top:5px;
    @media screen and (min-width:320px) and (max-width:350px){
        width: 85%;
        margin-left: -50px;
    }
    @media screen and (min-width:351px) and (max-width:374px){
        width: 85%;
        margin-left: -60px;
    }
    @media screen and (min-width:375px){
        width: 85%;
        margin-left: -65px;
    }
    @media screen and (min-width:376px) and (max-width:768px){
        width: 85%;
        margin-left: -75px;
    }
    @media screen and (min-width:1024px){
        width: 55%;
        margin-left: -40px;
    }
`

var Booknow = styled.div`
    bottom:0px;
    position: absolute;
    width: 100%;
    height:15%;
    background:rgba(225,0,0,.8);
    color:white;
    border-radius: 0 0px 8px 8px;
    display:flex;
    justify-content:center;
    align-items:center;
`

var Bottom = styled.div `
position: absolute;
bottom: 0;
width:100%;
height:12%;
background:rgba(225,0,0,.8);
color:white;
border-radius: 0 0px 8px 8px;
display:flex;
justify-content:center;
align-items:center;
`

export default function PopularActivitiesCard(props) {
    return <a href={props.link}>
        
  <Boxhover>
            <Container src={props.image}>
            <Price>{props.price}</Price>
            </Container>
            <Contentbox>
                    <Title></Title>
                    <Location>{props.title}</Location>
                    <Information>{props.description}</Information>
            </Contentbox>
           
            <Bottom>Book Now</Bottom>
            
  </Boxhover> 

  </a>
}